import { createSelector, MemoizedSelector } from '@ngrx/store';

import { Entity } from '../../../../interfaces/entity';
import { Shift } from '../../models/shift';
import * as fromShiftSettings from '../reducers/shift-settings.reducer';
import * as fromFeature from './../reducers';

export const getShiftStateSlice: MemoizedSelector<object, any> = createSelector(
  fromFeature.getShiftState,
  (state: fromFeature.ShiftState) => state.shiftSettings
);

export const getShiftSettingsEntities: MemoizedSelector<
  object,
  Entity<Shift>
> = createSelector(
  getShiftStateSlice,
  fromShiftSettings.getAccountShiftSettingEntities
);

export const getShiftSettings: MemoizedSelector<
  object,
  Array<Shift>
> = createSelector(
  getShiftSettingsEntities,
  (entities: Entity<Shift>) => {
    return Object.keys(entities).map((id: string) => entities[id]);
  }
);

export const getShiftSettingsLoading: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getShiftStateSlice,
  fromShiftSettings.getShiftStateLoading
);

export const getShiftSettingsLoaded: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getShiftStateSlice,
  fromShiftSettings.getShiftStateLoaded
);
